// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + (chunkId === 963 ? "upload worker" : chunkId) + "." + {207: "8c51b2a38d",372: "f8115da8fe",963: "af4736037a",}[chunkId] + ".js"
}